import type { TableProps } from 'antd';

export const computerSpecData: ComputerSpecType[] = [
  {
    key: '1',
    name: 'CPU',
    age: 'i5-11세대 / 라이젠5 7600x 이상',
    tel: 'i7-11 세대 이상'
  },
  {
    key: '2',
    name: 'RAM',
    tel: '32GB',
    age: '32GB'
  },
  {
    key: '3',
    name: 'GPU',
    age: 'Intel 내장그래픽 / AMD 내장그래픽',
    tel: 'GTX 1650'
  },
  {
    key: '4',
    name: '용량',
    age: '256GB 이상'
  },
  {
    key: '5',
    name: '해상도',
    age: '1920 * 1080 (FHD) 이상'
  },
  {
    key: '6',
    name: 'OS ver.',
    age: 'Windows 10 / 11 home / pro'
  }
];

export const computerSpecDataColumns: TableProps<ComputerSpecType>['columns'] = [
  {
    title: '구분',
    dataIndex: 'name'
  },
  {
    title: '엑스바디 검사 서비스 이용시',
    dataIndex: 'age',
    onCell: (_, index) => {
      if (index === 3) {
        return { colSpan: 3 };
      }
      if (index === 4) {
        return { colSpan: 3 };
      }
      if (index === 5) {
        return { colSpan: 3 };
      }
      return {};
    }
  },
  {
    title: '메타짐 동시 이용시',
    dataIndex: 'tel',
    onCell: (_, index) => {
      if (index === 3) {
        return { colSpan: 0 };
      }
      if (index === 4) {
        return { colSpan: 0 };
      }
      if (index === 5) {
        return { colSpan: 0 };
      }

      return {};
    }
  }
];
